/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
export * from './doctor-name.pipe';
export * from './location.pipe';
export * from './patient-name.pipe';
export * from './physician-name.pipe';
export * from './user-name.pipe';
export * from './verified-timer.pipe';
export * from './work-item.pipe';
export * from './epoch-time-ago.pipe';
export * from './rad-name.pipe';
export * from './age.pipe';
export * from './date-time.pipe';

export * from './app-pipes.module';
